class ProductFormSizeSelector extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.handleToggle = this.handleToggle.bind(this)
    this.handleOptionClick = this.handleOptionClick.bind(this)
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    this.handleAtcClick = this.handleAtcClick.bind(this)

    this.listeners.add(this.els.toggle.element, 'click', this.handleToggle)
    this.listeners.add(document, 'click', this.handleOutsideClick)

    if (this.els.atc?.exists) {
      this.listeners.add(this.els.atc.element, 'click', this.handleAtcClick)

      this.addedTimeout = null

      window.BAO.eventBus.addEventListener(
        window.BAO.EVENTS.PUSH_CART.BEFORE_ADD_FROM_FORM,
        () => {
          clearTimeout(this.addedTimeout)
          this.classList.remove('prd-DetailOption-added')
          this.setAttribute('aria-busy', 'true')
        },
      )

      window.BAO.eventBus.addEventListener(
        window.BAO.EVENTS.PUSH_CART.AFTER_ADD_FROM_FORM,
        () => {
          this.setAttribute('aria-busy', 'false')
          this.classList.add('prd-DetailOption-added')

          this.addedTimeout = setTimeout(() => {
            this.classList.remove('prd-DetailOption-added')
          }, 4200)
        },
      )

      window.BAO.eventBus.addEventListener(window.BAO.EVENTS.CART.ERROR, () => {
        this.setAttribute('aria-busy', 'false')
      })
    }

    const optionButtons = this.els.dropdown.element.querySelectorAll(
      '[data-faux-options-el="trigger"]',
    )
    optionButtons.forEach((optionEl) => {
      this.listeners.add(optionEl, 'click', this.handleOptionClick)
    })

    if (this.externalEls.trigger?.exists) {
      this.externalEls.trigger.elements.forEach((triggerEl) => {
        this.listeners.add(triggerEl, 'click', this.handleToggle)
      })
    }
  }

  handleToggle (event) {
    event.preventDefault()
    event.stopPropagation()

    const isExpanded =
      this.els.toggle.element.getAttribute('aria-expanded') === 'true'

    // Use mobile drawer instead
    if (!window.BAO.MediaBreakpoints.isMd && this.dataset.mobileDrawerKey) {
      if (isExpanded) this.close()
      window.drawers.activeDrawerKey = this.dataset.mobileDrawerKey

      return
    }

    if (isExpanded) {
      this.close()
    } else {
      this.open()
    }
  }

  open () {
    this.els.toggle.element.setAttribute('aria-expanded', 'true')
    this.els.dropdown.element.setAttribute('aria-hidden', 'false')
  }

  close () {
    this.els.toggle.element.setAttribute('aria-expanded', 'false')
    this.els.dropdown.element.setAttribute('aria-hidden', 'true')
  }

  handleOutsideClick (event) {
    if (!this.contains(event.target)) {
      this.close()
    }
  }

  handleAtcClick (event) {
    if (!this.els.atc?.exists) return

    if (this.els.atc.element.hasAttribute('data-no-selection')) {
      event.preventDefault()
      event.stopPropagation()

      if (!window.BAO.MediaBreakpoints.isMd && this.dataset.mobileDrawerKey) {
        const isExpanded =
          this.els.toggle.element.getAttribute('aria-expanded') === 'true'

        if (isExpanded) this.close()
        window.drawers.activeDrawerKey = this.dataset.mobileDrawerKey

        return
      }

      this.open()
    }
  }

  handleOptionClick (event) {
    const optionEl = event.target.closest('[data-faux-options-el="trigger"]')
    if (!optionEl) return

    const isNonSelectableOption = !!optionEl.closest(
      '[data-view-similar-external-el="trigger"], [data-back-in-stock-external-el="trigger"]',
    )

    requestAnimationFrame(() => {
      this.close()

      if (isNonSelectableOption) return

      if (this.els.indicator?.exists) {
        this.els.indicator.elements.forEach((el) => {
          el.classList.remove('prd-DetailOption_Text-light')
        })
      }

      if (this.els.atc?.exists) {
        this.els.atc.element.removeAttribute('data-no-selection')
        this.els.atc.element.disabled = false
      }

      this.hideMakeSelection()
    })
  }

  hideMakeSelection () {
    if (!this.externalEls['make-selection']?.exists) return

    this.externalEls['make-selection'].elements.forEach((btn) => {
      btn.setAttribute('aria-hidden', 'true')
    })
  }
}

if (!customElements.get('product-form-size-selector')) {
  customElements.define('product-form-size-selector', ProductFormSizeSelector)
}
